<template>
	<fragment>
		<common-header
			subname="사이트관리"
			name="사이트 설정 수정"
			v-bind:searchbox="false"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav">
				&nbsp;
			</nav>

			<div class="container-fiuld class-making-box clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						사이트 설정 수정
					</div>
				</div>
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">
						사이트 이름
					</p>
					<div class="input-group full-width">
						<span class="input-group-addon p-r-5">
							<input class="form-control-sm m-b-0 round full-width" v-model="boardName"
								type="text" placeholder="사이트명을 입력하세요.">
						</span>
					</div>

					<p class="f-12 m-b-0">
						사이트 이름 노출
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon p-r-5">
							<select v-model="boardType.boardNameHide">
								<option value="0">노출함</option>
								<option value="1">노출하지 않음</option>
							</select>
						</span>
					</div>

					<!-- <p class="f-12 m-b-0">
						사이트 노출설정
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon p-r-5">
							<select v-model="hideEnable">
								<option value="0">노출함</option>
								<option value="1">노출하지 않음</option>
							</select>
						</span>
					</div> -->
				</div>

				<button class="btn m-t-5" @click="createBoard()">저장</button>
			</div>
		</section>
		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import Axios from 'axios'
import server from '../statics/server'

export default {
	name: "ViewSiteSettingModify",
	mixins: [fnAdjustHeight],

	mounted: function() {
		Axios.post(server.addr()+server.api.SITE+"/"+this.$route.params.boardId).then((response) => {
			const { return : data } = response.data;
			this.lecId = data.lecId || 0;
			this.boardName = data.boardName || "";
			this.hideEnable = data.hideEnable || 0;
			this.boardGuide = data.boardGuide || "";
			this.writeAuth = data.writeAuth || "";
			this.readAuth = data.readAuth || "";
			this.commentAuth = data.commentAuth || "";
			this.replyAuth = data.replyAuth || "";
			this.listAuth = data.listAuth || "";
			this.atchFileUploadAuth = data.atchFileUploadAuth || "";
			this.secretTextEnabled = data.secretTextEnabled || 0;
			this.articleCategoryList = data.articleCategoryList || [];
			this.boardType = data.boardType && JSON.parse(data.boardType) || {
				boardNameHide: 0,
				pageSize: 5,
				articleListType: "",
				articleDetailType: "",
				articleWriteType: ""
			};
		});
	},

	components: {
		CommonHeader,
		CommonFooter,
		ModalConfirm,
		ModalAlert
	},

	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},

			// * bind data
			buttons: [],
			menus: [],

      // * select data
			authOptions: "",
			categoryInput: "",
			modifyIdx: null,

			// * server response data
			lecId: 0,
			boardName: "",
			hideEnable: 0,
			boardGuide: "",
			writeAuth: "",
			readAuth: "",
			commentAuth: "",
			replyAuth: "",
			listAuth: "",
			atchFileUploadAuth: "",
			secretTextEnabled: false,
			articleCategoryList: [],
			boardType: {
				boardNameHide: 0,
				pageSize: 5,
				articleListType: "",
				articleDetailType: "",
				articleWriteType: ""
			},

			boardTypeSelect: server.boardTypeSelect
		}
	},

	methods: {
		selectOptions: function(idx, e) { // * 권한 설정
			let { value } = e.target;

			let target;
			switch(idx) {
				case 0: target = "writeAuth"; break;
				case 1: target = "readAuth"; break;
				case 2: target = "commentAuth"; break;
				case 3: target = "replyAuth"; break;
				case 4: target = "listAuth"; break;
				case 5: target = "atchFileUploadAuth"; break;
				default: return;
			}

			if (this[target].indexOf(value) === -1) {
				if(value === "ALL") this[target]="회원,비회원"
				else this[target] += !this[target] ? value : `,${value}`;
			}

			// this.authOptions = ""
		},
		removeAuth: function(idx, auth) {
			let target;
			switch(idx) {
				case 0: target = "writeAuth"; break;
				case 1: target = "readAuth"; break;
				case 2: target = "commentAuth"; break;
				case 3: target = "replyAuth"; break;
				case 4: target = "listAuth"; break;
				case 5: target = "atchFileUploadAuth"; break;
				default: return;
			}
			this[target] = this[target].split(",").filter(e=>e!==auth).join(",");
		},
		addCategory: function() { // * 분류 추가
			this.articleCategoryList.push({boardId:this.$route.params.boardId, name:this.categoryInput});
			this.categoryInput = "";
		},
		modifyCategory: function(idx) {  // * 분류 수정 버튼 클릭 시
			this.categoryInput = this.articleCategoryList[idx].name;
			this.modifyIdx = idx;
		},
		cancleModify: function() { // * 분류 수정 진행 취소
			this.categoryInput = "";
			this.modifyIdx = null;
		},
		finishModify: function() { // * 분류 수정 
			this.articleCategoryList[this.modifyIdx].name = this.categoryInput;
			Axios.patch(server.addr()+server.api.ARTICLE_CATEGORY+"/"+this.articleCategoryList[this.modifyIdx].articleCategoryId, this.articleCategoryList[this.modifyIdx])
			.then(() => {
				this.categoryInput = "";
				this.modifyIdx = null;
			})
			.catch(() => {
				this.modals.ModalAlert.msg = "통신 오류! 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;	
			})
		},
		removeCategory: function(idx) { // * 분류 삭제
			if(this.articleCategoryList[idx].articleCategoryId)
				Axios.delete(server.addr()+server.api.ARTICLE_CATEGORY+"/"+this.articleCategoryList[idx].articleCategoryId)
				.then(() => {
					this.articleCategoryList.splice(idx, 1);
				})
				.catch(() => {
					this.modals.ModalAlert.msg = "통신 오류! 잠시 후 다시 시도해주세요.";
					this.modals.ModalAlert.show = true;					
				})
			else
				this.articleCategoryList.splice(idx, 1);
		},
		createBoard: async function() { // * 수정 API call
			const { lecId, boardName, hideEnable, boardGuide, writeAuth, readAuth, replyAuth, commentAuth,
			listAuth, atchFileUploadAuth, secretTextEnabled, articleCategoryList, boardType} = this;

			Axios.patch(server.addr()+server.api.SITE+"/"+this.$route.params.boardId, {
				lecId, boardName, hideEnable, boardGuide, writeAuth, readAuth, replyAuth, commentAuth,
				listAuth, atchFileUploadAuth, secretTextEnabled, articleCategoryList, boardType : JSON.stringify(boardType)
			})
			.then(() => {
				this.modals.ModalAlert.msg = "사이트 설정을 수정했습니다.";
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.btn.fn = () => {
					this.$router.push("/site/"+this.$route.params.boardId);
				}
			})
			.catch(() => {
				this.modals.ModalAlert.msg = "통신 오류! 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			})
		}
	}
}
</script>
